import React, { useState, useEffect } from "react";

const words = ["deep", "reliable", "suitable"];

export default function TypingWords() {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const timeout2 = setInterval(() => {
      setBlink((v) => !v);
    }, 500);

    return () => clearInterval(timeout2);
  }, []);

  useEffect(() => {
    if (!deleting && subIndex === words[index].length) {
      setTimeout(() => setDeleting(true), 1000);
      return undefined;
    }

    if (deleting && subIndex === 0) {
      setDeleting(false);
      setIndex((prev) => (prev + 1) % words.length);
      return undefined;
    }

    const timeout = setTimeout(() => {
      setSubIndex((prev) => prev + (deleting ? -1 : 1));
    }, deleting ? 60 : 120);

    return () => clearTimeout(timeout);
  }, [subIndex, deleting, index]);

  return (
    <span className="gradient-text font-extrabold">
      {words[index].substring(0, subIndex)}
      <span
        className="inline-block w-[3px] ml-0.5"
        style={{
          background: blink
            ? "linear-gradient(180deg, #10b981, #059669)"
            : "transparent",
          height: "0.85em",
          verticalAlign: "baseline",
          borderRadius: "1px",
        }}
      />
    </span>
  );
}
